// Widget Registry
// Maps widget IDs to their implementation and metadata

// We will import widgets here as they are implemented
import AircraftInfoWidget from "../widgets/AircraftInfoWidget";
import ActiveFlightsWidget from "../widgets/ops/ActiveFlightsWidget";
import FleetStatusWidget from "../widgets/ops/FleetStatusWidget";
import OpsAlertWidget from "../widgets/ops/OpsAlertWidget";
import FlightTimelineWidget from "../widgets/ops/FlightTimelineWidget";
import AircraftStatusListWidget from "../widgets/ops/AircraftStatusListWidget";
import InvoiceLifecycleWidget from "../widgets/settlement/InvoiceLifecycleWidget";
import AuditedExpensesWidget from "../widgets/settlement/AuditedExpensesWidget";
import SalesRouteProfitabilityWidget from "../widgets/settlement/SalesRouteProfitabilityWidget";
import OpsQuickAccessWidget from "../widgets/ops/OpsQuickAccessWidget";
import SettlementQuickAccessWidget from "../widgets/settlement/SettlementQuickAccessWidget";
import UldQuickAccessWidget from "../widgets/uld/UldQuickAccessWidget";
import SystemPortalWidget from "../widgets/common/SystemPortalWidget";
import FlightHoursMixedWidget from "../widgets/settlement/FlightHoursMixedWidget";

export const WIDGET_REGISTRY = {
    aircraft_info: {
        id: "aircraft_info",
        title: "机队概览",
        component: AircraftInfoWidget,
        permission: "masterdata:view", // Assuming this is the basic view permission
        defaultSize: { w: 2, h: 1 },
        description: "展示机队基本信息概览",
    },
    active_flights_monitor: {
        id: "active_flights_monitor",
        title: "今日动态航班",
        component: ActiveFlightsWidget,
        permission: "flight_operation:read_basic",
        defaultSize: { w: 2, h: 2 },
        description: "展示今日出发、到达及延误的航班动态",
    },
    fleet_status_overview: {
        id: "fleet_status_overview",
        title: "空中机队 (Airborne)",
        component: FleetStatusWidget,
        permission: "flight_operation:read_basic",
        defaultSize: { w: 2, h: 1 },
        description: "展示当前在空中飞行的飞机及航线信息",
    },
    ops_alert_feed: {
        id: "ops_alert_feed",
        title: "运行通告 (OCC Notes)",
        component: OpsAlertWidget,
        permission: "flight_operation:read",
        defaultSize: { w: 2, h: 2 },
        description: "展示最新的运行控制中心(OCC)通告和备注",
    },
    flight_timeline_widget: {
        id: "flight_timeline_widget",
        title: "航班排班 (Timeline)",
        component: FlightTimelineWidget,
        permission: "flight_operation:read_basic",
        defaultSize: { w: 4, h: 2 }, // Wider for timeline
        description: "展示未来一周的航班排班时间轴",
    },
    aircraft_status_list: {
        id: "aircraft_status_list",
        title: "机队状态监控",
        component: AircraftStatusListWidget,
        permission: "flight_operation:read",
        defaultSize: { w: 2, h: 4 }, // Taller for list
        description: "以卡片形式展示每架飞机的当前状态及事务办理情况",
    },
    invoice_lifecycle: {
        id: "invoice_lifecycle",
        title: "账单处理生命周期",
        component: InvoiceLifecycleWidget,
        permission: "settlement:ap_invoice_data_source:read",
        defaultSize: { w: 2, h: 2 },
        description: "展示账单从接收到入库的各阶段数量统计",
    },
    audited_expenses: {
        id: "audited_expenses",
        title: "当月已审核费用",
        component: AuditedExpensesWidget,
        permission: "settlement:ap_invoice_data_source:read",
        defaultSize: { w: 2, h: 2 },
        description: "展示当月已审核通过的各类型费用占比",
    },
    sales_route_profitability: {
        id: "sales_route_profitability",
        title: "航线盈利排行",
        component: SalesRouteProfitabilityWidget,
        permission: "settlement:ap_invoice_data_source:read",
        defaultSize: { w: 2, h: 2 },
        description: "展示最近完成核算的航线盈利情况",
    },
    ops_quick_access: {
        id: "ops_quick_access",
        title: "运行控制中心",
        component: OpsQuickAccessWidget,
        permission: "flight_operation:read_basic",
        defaultSize: { w: 4, h: 4 }, // Increased size
        description: "运行人员常用功能快速入口",
    },
    settlement_quick_access: {
        id: "settlement_quick_access",
        title: "结算中心",
        component: SettlementQuickAccessWidget,
        permission: "settlement:read",
        defaultSize: { w: 4, h: 4 }, // Increased size
        description: "结算人员常用功能快速入口",
    },
    uld_quick_access: {
        id: "uld_quick_access",
        title: "ULD管理中心",
        component: UldQuickAccessWidget,
        permission: "uld:read",
        defaultSize: { w: 4, h: 4 },
        description: "ULD管理人员常用功能快速入口",
    },
    system_portal: {
        id: "system_portal",
        title: "全业务模块门户 (System Portal)",
        component: SystemPortalWidget,
        // No specific permission required to VIEW the widget, acts as a portal.
        // Individual buttons will navigate to protected routes.
        permission: null,
        defaultSize: { w: 12, h: 5 }, // Full width, tall enough for 2 rows of large cards
        description: "集成OPS、结算、销售、ULD、统计等全业务模块的统一可视化入口",
    },
    flight_hours_mixed: {
        id: "flight_hours_mixed",
        title: "BH/FH飞行小时统计",
        component: FlightHoursMixedWidget,
        permission: "settlement:read|flight_operation:read",
        defaultSize: { w: 6, h: 6 },
        description: "展示结算数据与MVT实时数据混合的飞行小时统计",
    },
};

/**
 * Helper to get widget configuration by ID
 */
export const getWidgetConfig = (widgetId) => {
    return WIDGET_REGISTRY[widgetId];
};

/**
 * Helper to get all registered widgets
 */
export const getAllWidgets = () => {
    return Object.values(WIDGET_REGISTRY);
};
